<template>
  <div class="sh_empty_container" :class="customClass">
    <el-empty class="sh_empty" v-bind="$attrs" :description="$attrs.description || '暂无数据'">
      <slot v-for="(_, name) in $slots" :name="name" :slot="name"></slot>
    </el-empty>
  </div>
</template>

<script>
export default {
  name: 'ShEmpty',
  props: {
    customClass: String
  }
}
</script>

<style lang="scss">
@import '../../../assets/css/theme.scss';
.sh_empty_container {
  background-color: $white-bg;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
